export default {
  login: 'pulkit-upadhyay',
  id: 42133389,
  node_id: 'MDQ6VXNlcjQyMTMzMzg5',
  avatar_url: 'https://avatars3.githubusercontent.com/u/42133389?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/pulkitupadhyay16',
  html_url: 'https://github.com/pulkitupadhyay16',
  followers_url: 'https://api.github.com/users/pulkitupadhyay16/followers',
  following_url:
    'https://api.github.com/users/pulkitupadhyay16/following{/other_user}',
  gists_url: 'https://api.github.com/users/pulkitupadhyay16/gists{/gist_id}',
  starred_url:
    'https://api.github.com/users/pulkitupadhyay16/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/pulkitupadhyay16/subscriptions',
  organizations_url: 'https://api.github.com/users/pulkitupadhyay16/orgs',
  repos_url: 'https://api.github.com/users/pulkitupadhyay16/repos',
  events_url: 'https://api.github.com/users/pulkitupadhyay16/events{/privacy}',
  received_events_url:
    'https://api.github.com/users/pulkitupadhyay16/received_events',
  type: 'User',
  site_admin: false,
  name: 'Pulkit Upadhyay',
  company: 'null',
  blog: 'null',
  location: 'India',
  email: null,
  hireable: null,
  bio: 'funtime coder',
  twitter_username: 'null',
  public_repos: 152,
  public_gists: 0,
  followers: 1495,
  following: 0,
  created_at: '2018-08-06T06:48:23Z',
  updated_at: '2020-07-08T05:01:32Z',
};
